import { declareString } from "@1js/localization";

export const AuthorLabel = declareString(
  "promptLibrary.promptPreviewAuthorLabel",
  {
    text: "Author",
    comment:
      "Label for the Copilot prompt's author component shown on the prompt card.",
  }
);

export const WorkgroupLabel = declareString(
  "promptLibrary.promptPreviewWorkgroupLabel",
  {
    text: "Team",
    comment:
      "Label for the Copilot prompt's Workgroup component shown on the prompt card.",
  }
);
